// @flow
import React, { useState, } from 'react';
import { FelaComponent, } from 'react-fela';
import { parseStyleProps, } from '@haaretz/htz-css-tools';
import { IconPlus, IconClose, } from '@haaretz/htz-components';

import type { Node, } from 'react';
import type { StyleProps, } from '@haaretz/htz-css-tools';

type Props = {
  info: string,
  title: string,
  miscStyles?: ?StyleProps,
}

AdditionalInfo.defaultProps = {
  miscStyles: null,
};

function AdditionalInfo({ miscStyles, info, title, }: Props): Node {
  const [ isOpen, setIsOpen, ] = useState(false);

  return (
    <FelaComponent
      style={({ theme, }) => ({
        extend: [
          ...(miscStyles ? parseStyleProps(miscStyles, theme.mq, theme.type) : []),
        ],
      })}
    >
      <FelaComponent
        style={({ theme, }) => ({
          position: 'absolute',
          bottom: '0',
          end: '0',
          extend: [
            theme.type(-1),
          ],
        })}
      >
        {({ className, }) => (
          <button
            type="button"
            className={className}
            onClick={() => { setIsOpen(!isOpen); }}
          >
            <IconPlus miscStyles={{ marginEnd: '1rem', }} />
            {title}
          </button>
        )}
      </FelaComponent>
      <FelaComponent
        style={({ theme, }) => ({
          position: 'absolute',
          top: '1rem',
          display: isOpen ? 'block' : 'none',
          backgroundColor: theme.color('neutral', '-10'),
          paddingTop: '3rem',
          paddingStart: '2rem',
          paddingBottom: '2rem',
          paddingEnd: '2rem',
          zIndex: '2',
        })}
      >
        <FelaComponent
          style={{
            position: 'absolute',
            top: '0',
            end: '1rem',
          }}
        >
          {({ className, }) => (
            <button
              onClick={() => { setIsOpen(!isOpen); }}
              type="button"
              className={className}
            >
              <IconClose size={2} />
            </button>
          )}
        </FelaComponent>
        {info}
      </FelaComponent>
    </FelaComponent>
  );
}

export default AdditionalInfo;
